import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function deleteInvoice(invoiceNo: string) {
  const res = await fetchOrchidAPI(`/api/invoicing/entry/${invoiceNo}`, {
    method: "DELETE",
  });
  if (!res.ok) {
    throw new Error(
      `failed to delete invoice: ${getErrorDetail(await res.text())}`,
    );
  }
  return res.json();
}
